module.exports = __webpack_public_path__ + "assets/c0c64b011384774d899b1e74969da2ea.mp3";